
import React, { useEffect, useRef, useState } from "react";
import { getItem, getItembySearchWithTotal, getItemGroup, GetPrintData, PostCartItemApi, removeItemInTable, SoPostApi, SqPostApi, UpdateSalesQuotation } from "../APIServices/ItemPageService/ItemPageThunk";
import Header from "../sharedFiles/header/header";
import { useDispatch, useSelector } from "react-redux";
// import BackIcon from "../itemPage copy/BackIcon";
import { calculateGrandTotal, getDecryptedUser, handleDeleteRowCommon, showSuccess, useCartUtils } from "./ItemPageShared/ItemUtils";
import SpinnerLoader from "../sharedFiles/loader/spinnerLoader";
import dayjs from "dayjs";
import { toast, ToastContainer } from "react-toastify";
import SalesQuotationModal from "../salesQuotationModal/salesQuotationModal";
import handlePrinter from "../GenerateReport/generateReport";
import ItemCardView from "./CardView/itemCardView";
import Summery from "./ItemPageShared/summery";
import { useCart } from "./ItemPageShared/itemContext";
import BackIcon from "./ItemPageShared/BackIcon";
import Footer from "../sharedFiles/footer/footer";
import { useLocation } from "react-router-dom";
import TableView from "./TableView1/tableView";


const ItemPage = () => {

    const [isTableView, setIsTableView] = useState(false);
    const location = useLocation();
    const { checked } = location.state || {};
    const [itemSearchTerm, setItemSearchTerm] = useState("");
    // const [displayedItem, setDisplayedItem] = useState([]);
    // const [scrollPage,setScrollPage]=useState(0)
    const dispatch = useDispatch();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [searchColumn, setSearchColumn] = useState("");
    const [itemByGrpCode, setItemByGrpCode] = useState(false);
    // const [searchItem, setSearchItem] = useState(false);
    // const [totalCount, setTotalCount] = useState(0);
    const [groupCode, setGroupCode] = useState("");
    const [cartUpdated, setCartUpdated] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [orderType, setOrderType] = useState([]);
    const [rows, setRows] = useState([{}]);
    const [inputValue, setInputValue] = useState(() => {
        const storedData = sessionStorage.getItem('CustomerDetails');
        return storedData ? JSON.parse(storedData) : {};
    });
    const [isFetchingNextPage, setIsFetchingNextPage] = useState(false);
    const { handleQuantityChange } = useCartUtils();
    const hasInputValues = Object.values(inputValue).some(val => val);
    const [isOtherCustomer, setIsOtherCustomer] = useState(hasInputValues ? true : false);
    const [remarks, setRemarks] = useState("");
    const [DueDate, setDueDate] = React.useState(() => dayjs());
    const Ddate = dayjs(DueDate).format("YYYY-MM-DD");
    const [showPrintButton, setShowPrintButton] = useState(false);
    const [callInProgress, setCallInProgress] = useState(
        {
            itemSearch: false,
            historyPage: false,
            checkout: false,
            printing: false,
            getIniItem: false,
            getPasteItems: false,

        });

    const userData = getDecryptedUser();
    const userId = userData[0]?.UserId;
    const CardName = userData[0]?.CardName;
    const storedData = sessionStorage.getItem('CustomerDetails');
    const { loading, error, GetItemGrp, GetCartItm, UpdateSq, GetItm, GetItmBySearch, PostSq, PostSo, PrintData, ItemDetailsbyPasting } = useSelector((state) => state.itemPage);
    const isLoading = () => {
        return (
            loading.GetItmBySearch ||
            loading.PostCartItm ||
            loading.PostSo ||
            loading.PostSq ||
            loading.RemoveItmInTable ||
            loading.PrintData ||
            loading.GetItm ||
            loading.UpdateSq ||
            loading.ItemDetailsbyPasting

        );
    };
    const { cart, setCartItems,
        setGrandTotal, setPage, page,
        searchResults, setSearchResults, setDisplayedItem } = useCart();
    const handleCheckBox = () => {
        setIsOtherCustomer(prev => !prev);

    };


    const inputfieldLabel = ["customer_Name", "phone_Number", "customer_Address", "margin_Percentage"];
    useEffect(() => {
        if (GetCartItm && Array.isArray(GetCartItm)) {
            setCartItems(prevCart => {
                // Optional: prevent duplicates based on itemCode or any unique key
                const newItems = GetCartItm.filter(
                    newItem => !prevCart.some(existing => existing.itemCode === newItem.itemCode)
                );
                localStorage.setItem("cart", JSON.stringify(newItems));
                return [...prevCart, ...newItems];
            });
        }
        if (!GetItemGrp) {
            dispatch(getItemGroup());
        }
    }, [GetCartItm, GetItemGrp]);
    useEffect(() => {
        if (cart.length === 0) {
            const storedCartData = sessionStorage.getItem("cart");
            if (storedCartData) {
                try {
                    const parsedCart = JSON.parse(storedCartData);
                    if (Array.isArray(parsedCart)) {
                        setCartItems(parsedCart);
                    }
                    const Total = calculateGrandTotal(parsedCart);
                    setGrandTotal(Total);
                } catch (e) {
                    console.error("Failed to parse stored cart:", e);
                }
            }
        }
    }, [cart.length]);

    const cleardata = () => {
        setTimeout(() => {
            dispatch(removeItemInTable());
            sessionStorage.removeItem('CustomerDetails')
            setCartItems([]);
            setInputValue({});
            setRemarks('');
            setItemSearchTerm("");
            setIsOtherCustomer(false)
            sessionStorage.removeItem('cart');
            setShowPrintButton(true);
            setRows([]);
            setGrandTotal(0);
        }, 500);
    };

    const APIChecker = () => {
        if (callInProgress.itemSearch && error.GetItmBySearchError) {
            const errorss = error.GetItmBySearchError;
            toast.error(errorss.errorMessage);
            setCallInProgress({ ...callInProgress, itemSearch: false });
        }

        if ( callInProgress.itemSearch &&GetItmBySearch &&
            !loading.GetItmBySearch) {
            if (GetItmBySearch?.items?.length > 0) {
                setSearchResults(prev =>
                    isFetchingNextPage
                        ? [...prev, ...GetItmBySearch?.items]
                        : GetItmBySearch?.items
                );
            } else if (!isFetchingNextPage) {
                setSearchResults([]);
            }
            setCallInProgress(prev => ({
                ...prev,
                itemSearch: false,
            }));
            setIsFetchingNextPage(false);
            setIsDropdownOpen(true);
        }


        if (callInProgress.checkout && !(loading.PostSo || loading.PostSq || loading.UpdateSq)) {
            const { PostSoError, PostSqError, UpdateSqError } = error;
            const anyError = PostSoError || PostSqError || UpdateSqError;
            if (anyError) {
                toast.error(anyError.errorMessage);
            }
            if (callInProgress.checkout && (PostSo || PostSq || UpdateSq)) {
                showSuccess();
                cleardata();
            }
            setCallInProgress({ ...callInProgress, checkout: false });
        }
        if (callInProgress.printing && !loading.PrintData) {
            setCallInProgress({ ...callInProgress, printing: false });
            if (error.PrintDataError) {
                const errorss = error.PrintDataError;
                toast.error(errorss.errorMessage);
            } else if (callInProgress.printing && PrintData) {
                setIsOtherCustomer(false);
                const orderData = (PostSo || PostSq || UpdateSq);
                const inpData = (PrintData);
                handlePrinter(inpData, orderType, CardName);
                setModalShow(false);
                setShowPrintButton(false);
                sessionStorage.removeItem('CustomerDetails');
            }
        }
        if (callInProgress.getIniItem && !loading.GetItm && isTableView) {
            if (error.GetItmError) {
                const errorss = error.GetItmError;
                toast.error(errorss.errorMessage);
            }
            if (GetItm && GetItm.length > 0) {
                setDisplayedItem(GetItm)
            } else {
                setDisplayedItem([])
            }
            setCallInProgress({ ...callInProgress, getIniItem: false });
        }
        if (callInProgress.getPasteItems && !loading.ItemDetailsbyPasting) {
            if (error.ItemDetailsbyPastingError) {
                const errorss = error.ItemDetailsbyPastingError;
                toast.error(errorss);
                setCallInProgress(prev => ({ ...prev, getPasteItems: false }));
            }
            else if (callInProgress.getPasteItems && ItemDetailsbyPasting) {

                const updatedCart = cart.map((item) => {
                    const apiItem = ItemDetailsbyPasting.find(api => api.item_Code === item.item_Code || api.item_Name === item.item_Name);
                    if (!apiItem) {
                        //    toast.error(`Item not found: ${item.item_Name || item.item_Code}`);
                        return item;
                    }
                    return {
                        ...apiItem,
                        // item_Code: item.item_Code, 
                        // item_Name: item.item_Name,  
                        // quantity: item.quantity,    
                    };
                });
                setCartItems(updatedCart);
                updateQuantities();
                setCallInProgress(prev => ({ ...prev, getPasteItems: false }));
            }
        }
    }
    useEffect(() => {
        APIChecker();
    }, [GetItemGrp, callInProgress, TableView, loading, error, PostSo, PostSq, UpdateSq, PrintData, ItemDetailsbyPasting, GetItmBySearch]);
    const updateQuantities = async () => {
        for (let i = 0; i < cart.length; i++) {
            await new Promise(res => setTimeout(res, 10)); // tiny delay
            handleQuantityChange(
                { target: { value: cart[i]?.quantity } },
                i,
                "quantity"
            );
        }
    };


    const handleToggleView = () => {
        setCallInProgress({ ...callInProgress, getIniItem: true });
        fetchData(GetItemGrp[0].itmsGrpCod);
        setIsTableView(!isTableView);
    };
    const handleItemSelect = (item, rowIndex, column) => {
        setIsDropdownOpen(false);
        setPage(1);
        setCartItems((prevCartItems) => {
            const updatedItems = [...prevCartItems];
            updatedItems[rowIndex] = item;
            sessionStorage.setItem("cart", JSON.stringify(updatedItems));
            return updatedItems;
        });
    };

    const fetchItemsBySearch = (value, pageNumber, column) => {
        if (value.length > 2) {
            setCallInProgress(prev => ({ ...prev, itemSearch: true }));
            dispatch(getItembySearchWithTotal({
                searchText: value,
                pageNumber: pageNumber, // use passed page number
                pageSize: 50,
                column: column
            }));
        }
    }

    const handleItemInputChange = (value, rowIndex, column) => {
        setSearchColumn(column)
        setItemSearchTerm(value);
        setCartItems(prev => {
            const updated = [...prev];
            const row = updated[rowIndex] || {};
            if (value === '') {
                updated[rowIndex] = {};
            } else {
                updated[rowIndex] = { ...row, [column]: value };
            }
            return updated;
        });
        setPage(1);
        fetchItemsBySearch(value, page, column);



    }
    const handleheadersearch = (e) => {
        const value = e.target.value; // remove spaces
        setItemSearchTerm(value);
        fetchItemsBySearch(value, 1);
    };



    const handleDeleteRow = (index) => {
        handleDeleteRowCommon({
            index,
            cart,
            setCartItems,
            setRows,
            setGrandTotal
        });
    };
    const handleGroupCodeChange = (code) => {
        setItemByGrpCode(true);
        fetchData(code);
    }
    const fetchData = async (code) => {
        const setGroupCode = code || groupCode
        setCallInProgress({ ...callInProgress, getIniItem: true });
        // setItemSearchTerm("");
        dispatch(getItem({ grpCode: setGroupCode }));
        // setRowsPerPage(10);
    };

    const handlecartUpdate = async () => {
        let userCart = Object.fromEntries(
            Object.entries(cart).map(([key, item]) => {
                let newItem = { ...item, userId }; // Create a new object
                if (!newItem.salUnitMsr) {
                    newItem.salUnitMsr = "0"; // If salUnitMsr will be empty means it will render 0
                }
                if (!newItem.CustomerCode) {
                    newItem.CustomerCode = userData?.CardCode;
                }
                if (!newItem.defaultPriceList) {
                    newItem.defaultPriceList = 0;
                }
                return [key, newItem];
            })
        );

        //****** This will helps to check cart item quantity have value and only a number *********/
        const validatedCart = Object.fromEntries(
            Object.entries(userCart).filter(([key, item]) =>
                Number.isInteger(item.quantity)
            )
        );
        //********* Here will convert a validated abject into array *********/
        const validatedCartArray = Object.values(validatedCart);
        // dispatch(setCart(validatedCart));
        dispatch(PostCartItemApi(validatedCartArray));
        sessionStorage.setItem("cart", JSON.stringify(validatedCart));
    }
    // #endregion
    // #region handle print function 
    const handleprint = async () => {
        const inpData = (PostSo || PostSq || UpdateSq);
        const updateDocEntry = localStorage.getItem('docEntry')
        const DocEntrys = orderType === 'Quote'
            ? inpData.docEntry
            : orderType === 'PurchaseOrder'
                ? inpData.docEntry
                : updateDocEntry;
        setCallInProgress({ ...callInProgress, printing: true });
        dispatch(GetPrintData({ docEntrys: DocEntrys, orderType: orderType }))

    }
    const handlecancel = () => {
        setModalShow(false);
        setShowPrintButton(false);
    }
    // #endregion 
    const handleCheckoutButtonClick = () => {
        const isCartEmpty = cart.length === 0;
        const isQuantityValid = cart.every(item => item.quantity && parseFloat(item.quantity) > 0);

        if (isCartEmpty) {
            console.log("its trigger checkout ", isCartEmpty);
            toast("Your cart is empty. Please add items to proceed.", {
                position: "bottom-right",
                theme: "dark",
            });
            return;
        }

        if (!isQuantityValid) {
            toast("Quantity must be greater than 0 for all items.", {
                position: "bottom-right",
                theme: "dark",
            });
            return;
        }
        // If both validations pass, open the modal
        setModalShow(true);
    }
    // #region final post for sales quatation , sales order, and update SQ 
    const handleCheckout = async (value, shouldNavigate) => {
        setOrderType(value);
        const customerData = { inputValue }
        // localStorage.setItem('CustomerDetails', JSON.stringify(customerData));
        const CustomerDetails = isOtherCustomer
            ? `CustomerName: ${inputValue.customer_Name}, Phone: ${inputValue.phone_Number}, Address: ${inputValue.customer_Address}`
            : '';
        // sessionStorage.setItem('CustomerDetails', (inputValue))

        const marginPercentage = isOtherCustomer
            ? inputValue.margin_Percentage
            : '';
        const isValidNumber = (value) => {
            return typeof value === "number" && !isNaN(value);
        };
        const hasInvalidItem = Object.values(cart || {}).some(
            (item) => !item.item_Code?.trim() || !item.item_Name?.trim()
        );
        if (hasInvalidItem) {
            toast.warning("Item Code or Item Name is Missing!");
            return;
        }

        const updatedCart = cart && Object.values(cart)?.map((row) => ({
            customerCode: userData?.CardCode,
            ItemCode: row.item_Code,
            // Price: row.discount_Price
            //     ? row.discount_Price
            //     : row.price || 0,
            Price: row.price,
            discountPercentage: row?.discount_Percentage,
            PriceAfterDiscount: row?.price_After_Discount,
            Quantity: parseInt(row.quantity, 10),
            DeliveryDate: Ddate,
            Remarks: remarks,
            BranchId: userData[0]?.BranchID,
            SplCode: userData[0]?.SalesEmpCode,
            LeadDetail: CustomerDetails,
            MarginPercentage: marginPercentage,

        }))
        const invalidItem = updatedCart.find((item) => {
            return !isValidNumber(item.Quantity) || item.Quantity <= 0;
        });

        if (invalidItem) {
            toast("Quantity must be greater than 0 for all items.", {
                position: "bottom-right",
                theme: "dark",
            });
            return;
        }

        let dataToSend;
        try {
            setCallInProgress({ ...callInProgress, checkout: true });
            if (value === "Quote") {
                dataToSend = {
                    quotationData: updatedCart,
                };

                dispatch(SqPostApi(dataToSend));
            }
            if (value === "PurchaseOrder") {
                dataToSend = {
                    quotationData: updatedCart,
                };
                dispatch(SoPostApi(dataToSend));
            } if (value === "UpdateQuote") {
                dataToSend = {
                    docEntry: cart[0].DocEntry,
                    quotationData: updatedCart,
                };
                dispatch(UpdateSalesQuotation(dataToSend));
            }
        } catch (error) {
            setCallInProgress({ ...callInProgress, checkout: false });
        }
    };
    // #endregion 
    return (
        <>
         <div className="ItemPage">
            <Header
                ItemInputChange={handleheadersearch}
                show={isTableView ? "show" : ""}
                itemSearchTerm={itemSearchTerm}
            />
            {/* <div className="dashImage"></div> */}
            {/* <div className="dashGradientIP"></div> */}

            <BackIcon
                cartUpdated={cartUpdated}
                handlecartUpdate={handlecartUpdate}
                setModalShow={setModalShow}
                handleGroupCodeChange={handleGroupCodeChange}
                handleToggleView={handleToggleView}
                isTableViews={isTableView}
            />
            <div className="d-flex">
                {isTableView ? (
                    <ItemCardView
                        itemByGrpCode={itemByGrpCode}
                        isTableView={isTableView}
                        itemSearchTerm={itemSearchTerm}
                        handleItemSelect={handleItemSelect}
                        handleDeleteRow={handleDeleteRow}
                    />
                ) : (
                    // <div className="ItemPage col-12">
                    <div className="itemDiv col-10 col-sm-10 col-xl-10 col-md-10 col-xxl-10">
                        {/* <div className="gradient col-xl-10 col-8"></div> */}

                        <TableView
                            setIsFetchingNextPage={setIsFetchingNextPage}
                            searchColumn={searchColumn}
                            itemSearchTerm={itemSearchTerm}
                            fetchItemsBySearch={fetchItemsBySearch}
                            setIsDropdownOpen={setIsDropdownOpen}
                            isFetchingNextPage={isFetchingNextPage}
                            searchResults={searchResults}
                            isDropdownOpen={isDropdownOpen}
                            setDueDate={setDueDate}
                            DueDate={DueDate}
                            handleItemInputChange={handleItemInputChange}
                            setModalShow={setModalShow}
                            remarks={remarks}
                            setRemarks={setRemarks}
                            handleCheckout={handleCheckout}
                            handleItemSelect={handleItemSelect}
                            modalShow={modalShow}
                            inputValue={inputValue}
                            setInputValue={setInputValue}
                            setRows={setRows}
                            rows={rows}
                            setCallInProgress={setCallInProgress}
                            callInProgress={callInProgress}
                            handleDeleteRow={handleDeleteRow}
                        />

                    </div>
                    // </div>
                )}
                <Summery
                    isTableView={isTableView}
                    handleCheckoutButtonClick={handleCheckoutButtonClick}
                    isOtherCustomer={isOtherCustomer}
                    handleCheckBox={handleCheckBox}
                    inputfieldLabel={inputfieldLabel}
                    inputValue={inputValue}
                    setInputValue={setInputValue}
                    setRemarks={setRemarks}
                    remarks={remarks}
                />
            </div>
            <SalesQuotationModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                handlecheckout={handleCheckout}
                handleprint={handleprint}
                handlecancel={handlecancel}
                showPrintButton={showPrintButton}
            />

            {isLoading() &&
                <div className='loader loaderbg position-absolute '>
                    <SpinnerLoader />
                </div>
            }
            <ToastContainer
                position="top-center"
                toastOptions={{
                    style: {
                        fontSize: '16px',
                        padding: '16px',
                        width: '400px',
                        borderRadius: '8px',
                    },
                }}
            />
            {/* <Footer
                className={isTableView ? "footer-itempage" : "footer-Ip"}
                logoPositionClass="logo-item-page"
            /> */}
            </div>
        </>
    );
};

export default ItemPage;